import { render, staticRenderFns } from "./m_upgrade.vue?vue&type=template&id=5d81bb86&scoped=true&"
import script from "./m_upgrade.vue?vue&type=script&lang=js&"
export * from "./m_upgrade.vue?vue&type=script&lang=js&"
import style0 from "./m_upgrade.vue?vue&type=style&index=0&id=5d81bb86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d81bb86",
  null
  
)

export default component.exports